import type { CurrencyFormatterOptions } from 'globalize';
import globalize from 'globalize';
// eslint-disable-next-line @typescript-eslint/no-require-imports
const Globalize = require('globalize');

/**
 * Formats a number as a currency string.
 *
 * @param {number} number - The number to format.
 * @param {boolean} valueIsDecimal - Whether the number is already in decimal format.
 * @param {CurrencyFormatterOptions} [extraOptions] - Additional options for the currency formatter.
 * @param {string} [languageCode] - The language code to use for formatting.
 * @returns {string} The formatted currency string.
 *
 * @example
 * // Returns "€1,000.00"
 * formatCurrency(100000, false, {}, 'en');
 */
export function formatCurrency(
    number: number,
    valueIsDecimal?: boolean,
    extraOptions?: CurrencyFormatterOptions,
    languageCode?: string
): string {
    // The globalize instance is initially set to the global instance from the app setup.
    // If a specific language code is provided, a new instance is created to avoid affecting the global instance's.
    const globalizeInstanceToUse = languageCode ? new Globalize(languageCode) : globalize;

    // Create a currency formatter with the specified options.
    const formatter = globalizeInstanceToUse.currencyFormatter('EUR', extraOptions);

    // If the number is not already in decimal format, convert it by dividing by 100.
    return formatter(valueIsDecimal ? number : number / 100);
}
